import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export const styles = css`
  .link-bank-container {
    padding: 24px 0px;
    border-top: 1px solid ${colors.G2};
    border-bottom: 1px solid ${colors.G2};
  }
  .link-bank-container:first-of-type {
    margin-top: 52px;
  }
  .link-bank-title {
    font-weight: 700;
    font-size: 20px;
    color: ${colors.BLACK};
    line-height: 26px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }
  .links-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px;
    gap: 0 5px;
  }
  .link-container {
    width: 32%;
    margin-bottom: 12px;
  }
  .link {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK};
  }
  .link:hover {
    color: red;
  }
  @media (max-width: ${screen.mdMax}) {
    .link-bank-container {
      margin: 0 24px;
    }
    .link-container {
      width: 40%;
    }
  }
  @media (max-width: ${screen.xsMax}) {
    .link-bank-container {
      padding: 24px 0px;
      border-top: 1px solid ${colors.G2};
      border-bottom: 1px solid ${colors.G2};
      margin: 0 16px;
    }
    .link-container {
      width: 100%;
    }
  }
`;
